import { render, staticRenderFns } from "./typeDetails.vue?vue&type=template&id=6ea7d2de&scoped=true&"
import script from "./typeDetails.vue?vue&type=script&lang=js&"
export * from "./typeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea7d2de",
  null
  
)

export default component.exports